var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32031 5.78809V19.8394C3.32031 21.5055 7.33498 22.8504 12.3533 22.8504C17.3717 22.8504 21.3863 21.5055 21.3863 19.8394V5.78809",
    fill: "url(#paint0_linear_1197_13252)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3533 8.7991C17.3421 8.7991 21.3863 7.45103 21.3863 5.7881C21.3863 4.12517 17.3421 2.7771 12.3533 2.7771C7.36453 2.7771 3.32031 4.12517 3.32031 5.7881C3.32031 7.45103 7.36453 8.7991 12.3533 8.7991Z",
    fill: "#BBBDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3863 12.8138C21.3863 14.4799 17.3717 15.8248 12.3533 15.8248C7.33498 15.8248 3.32031 14.4799 3.32031 12.8138",
    stroke: "url(#paint1_linear_1197_13252)",
    strokeWidth: 1.00367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_13252",
    x1: 3.82215,
    y1: 6.28992,
    x2: 21.8882,
    y2: 24.3559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C891E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2925FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_13252",
    x1: 12.3533,
    y1: 13.8175,
    x2: 12.3533,
    y2: 16.8285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD55FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon1);
export default __webpack_public_path__ + "static/media/drive_card_icon1.7d332d1a5abc2b61c024faa4422397d8.svg";
export { ForwardRef as ReactComponent };